import React from "react";
import MainAuth from "./MainAuth";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import ResetPassword from "src/components/authentication/ResetPassword";

const ResetPasswordView: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t("auth_reset_password_tab")}</title>
      </Helmet>
      <MainAuth>
        <ResetPassword />
      </MainAuth>
    </>
  );
};

export default ResetPasswordView;
